import ShelfApi from "~/utils/ShelfApi"

function callApiEndpoint(method, url, params = {}) {
  return new Promise(function(resolve, reject) {
    ShelfApi({
      method: method,
      url: url,
      data: params
    })
      .then(res => resolve(res.data))
      .catch(err => reject(err))
  })
}

class ApiEntity {
  constructor(name) {
    this.name = name
    this.api_base = "/" + this.name.toLowerCase() + "s/"
  }

  all() {
    // index
    return callApiEndpoint("get", this.api_base)
  }

  find(id) {
    // get
    return callApiEndpoint("get", this.api_base + id)
  }

  create(params) {
    return callApiEndpoint("post", this.api_base, params)
  }

  update(id, params) {
    return callApiEndpoint("put", this.api_base + id, params)
  }

  destroy(id) {
    return callApiEndpoint("delete", this.api_base + id)
  }
}

export const Product = new ApiEntity("Product")
export const Article = new ApiEntity("Article")
export const Area = new ApiEntity("Area")
export const Location = new ApiEntity("Location")
export const User = new ApiEntity("User")
export const Destination = new ApiEntity("Destination")
export const Tenant = new ApiEntity("Tenant")

export const getDeliveryNote = deliveryNoteNumber =>
  callApiEndpoint("get", "delivery_notes" + "/" + deliveryNoteNumber)

export const getReports = () => callApiEndpoint("get", "reports")

export function getPagedResources(path, page = 0, query = "") {
  const parsed = parseInt(page, 10)
  const pageInt = parsed > 0 ? parsed : 0

  return callApiEndpoint("get", path + "?page=" + pageInt + "&query=" + query)
}

export const getTransaction = (id, type) =>
  callApiEndpoint("get", type + "s/" + id)

export const transactionTypes = t => {
  return {
    ArticleRegistration: {
      name: t("articleRegistration"),
      icon: require("~/icons/article_registration_32_blue.svg")
    },
    StockIn: {
      name: t("stockIn"),
      icon: require("~/icons/stock_in_32_blue.svg")
    },
    Movement: {
      name: t("movement"),
      icon: require("~/icons/movement_32_blue.svg")
    },
    StockOut: {
      name: t("stockOut"),
      icon: require("~/icons/stock_out_32_blue.svg")
    },
    Restock: {
      name: t("restock"),
      icon: require("~/icons/restock_32_blue.svg")
    },
    StockUp: {
      name: t("stockUp"),
      icon: require("~/icons/stock_up_32_blue.svg")
    },
    ArticleExpiryDateRevision: {
      name: t("articleExpiryDateRevision"),
      icon: require("~/icons/article_revision_32_blue.svg")
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/ShelfEntities.js